exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".createTelegramBot-module__title--1ex1C {\n  display: flex;\n  width: 100%;\n  padding: 12px 16px;\n  border-bottom: 1px solid #f2f2f2;\n}\n.createTelegramBot-module__title--1ex1C > span {\n  font-size: 16px;\n}\n.createTelegramBot-module__content--1hdNg {\n  padding: 36px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.createTelegramBot-module__input--1MW2T {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.createTelegramBot-module__input--1MW2T > label {\n  text-transform: uppercase;\n  width: 70px;\n}\n.createTelegramBot-module__actions--3LDlV {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-inline-start: 85px;\n}", ""]);

// exports
exports.locals = {
	"title": "createTelegramBot-module__title--1ex1C",
	"content": "createTelegramBot-module__content--1hdNg",
	"input": "createTelegramBot-module__input--1MW2T",
	"actions": "createTelegramBot-module__actions--3LDlV"
};